module.exports = __webpack_public_path__ + "static/eis4-cf4ca665fe6811318d02c17a51d578e6.jpg";